import { PUB_SUB_CHANNEL_APP, PUB_SUB_CHANNEL_MODAL } from '@wix/communities-blog-client-common';
import { isMobile } from '../services/wix-sdk-utils';
import { hideModal } from './hide-modal';
import { closeWixModal } from './close-wix-modal';
import { isEditor } from '../selectors/view-mode-selectors';
import { isInWix } from '../services/is-in-wix';

export const closeModal = (payload) => (dispatch, getState) => {
  const state = getState();

  if (!state.isMembersExtension) {
    dispatch(
      hideModal(payload, {
        publish: [PUB_SUB_CHANNEL_APP, PUB_SUB_CHANNEL_MODAL],
      }),
    );
  } else {
    const action = hideModal(payload);

    dispatch(action);
    if (!isMobile() && isInWix() && !isEditor(getState())) {
      dispatch(closeWixModal(action));
    }
  }
};
